export const SLIDES = [
  {
    city: "Ujjain",
    sub: "Mahakaleshwar Darshan",
    badge: "Pilgrimage",
    km: "55 km · 1 hr",
  },
  {
    city: "Bhopal",
    sub: "Lake City · Corporate",
    badge: "Corporate",
    km: "195 km · 2.5 hrs",
  },
  {
    city: "Pachmarhi",
    sub: "MP's Hill Station",
    badge: "Leisure",
    km: "230 km · 4 hrs",
  },
  {
    city: "Mumbai",
    sub: "Overnight Drop",
    badge: "Outstation",
    km: "580 km · 9 hrs",
  },
];

export const STATS = [
  { num: "15,000+", label: "Trips Completed" },
  { num: "98%", label: "On-Time Arrival" },
  { num: "500+", label: "Corporate Clients" },
  { num: "12", label: "Cities Covered" },
];

export const SERVICES = [
  {
    id: "01",
    name: "Airport Transfer",
    desc: "Punctual pickups, flight-tracking, and a waiting chauffeur, so your journey starts before you land.",
    tag: "From ₹999",
    icon: "✈",
  },
  {
    id: "02",
    name: "Corporate Travel",
    desc: "Dedicated vehicles, monthly packages, GST billing, and account management for your executive team.",
    tag: "Monthly Plans",
    icon: "💼",
  },
  {
    id: "03",
    name: "Outstation Trips",
    desc: "Indore to Bhopal, Ujjain, Mumbai and beyond. One-way or round trips with experienced long-haul drivers.",
    tag: "Custom Quote",
    icon: "🛣",
  },
  {
    id: "04",
    name: "Local City Hire",
    desc: "Hourly or full-day hire across Indore. Meetings, shopping, events. Your car waits wherever you go.",
    tag: "₹3,500+ / day",
    icon: "🏙",
  },
  {
    id: "05",
    name: "Pilgrimage Tours",
    desc: "Ujjain, Omkareshwar, Mahakaleshwar and sacred circuits, with comfort and spiritual ease.",
    tag: "Group Packages",
    icon: "🪔",
  },
  {
    id: "06",
    name: "Wedding Fleet",
    desc: "Decorated vehicles and coordinated logistics for your most important day. Sedan to Bus, all available.",
    tag: "Fleet Available",
    icon: "💍",
  },
];

export const FLEET = [
  {
    id: "sedan",
    label: "Sedan",
    seats: "4 Passengers",
    models: "Swift Dzire, Honda Amaze",
    climate: "Full Climate Control",
    best: "City Rides & Outstation",
  },
  {
    id: "mpv",
    label: "MPV",
    seats: "7 Passengers",
    models: "Ertiga, Innova Crysta",
    climate: "Full Climate Control",
    best: "Family, Corporate & Pilgrimages",
  },
  {
    id: "traveller",
    label: "Traveller",
    seats: "17–26 Passengers",
    models: "Traveller",
    climate: "Full Climate Control",
    best: "Group Tours & Events",
  },
  {
    id: "bus",
    label: "Bus",
    seats: "30–52 Passengers",
    models: "Full-Size Coach Bus",
    climate: "Full Climate Control",
    best: "Large Groups & Weddings",
  },
];

export const DESTINATIONS = [
  {
    city: "Bhopal",
    km: "195 km · 2.5 hrs",
    info: "NH-46 · Corporate & family trips",
  },
  { city: "Ujjain", km: "55 km · 1 hr", info: "NH-52 · Mahakaleshwar darshan" },
  {
    city: "Mumbai",
    km: "580 km · 9 hrs",
    info: "NH-3 · Overnight drops available",
  },
  {
    city: "Omkareshwar",
    km: "80 km · 1.5 hrs",
    info: "Narmada ghats & Jyotirlinga",
  },
  {
    city: "Mandu",
    km: "98 km · 2 hrs",
    info: "Historical ruins & Malwa plateau",
  },
  {
    city: "Pune",
    km: "530 km · 8.5 hrs",
    info: "NH-48 · Business delegations",
  },
  {
    city: "Pachmarhi",
    km: "230 km · 4 hrs",
    info: "MP's hill station · Weekends",
  },
  { city: "Custom Route", km: "Anywhere", info: "Request your destination →" },
];

export const WHY = [
  {
    id: "01",
    title: "Verified, Trained Chauffeurs",
    desc: "Every driver is background-verified, defensive-driving trained, and regularly evaluated for performance and guest satisfaction.",
  },
  {
    id: "02",
    title: "No Surge Pricing, Ever",
    desc: "We quote a fair price upfront, regardless of time, traffic, or demand. No surprises at the end of your journey.",
  },
  {
    id: "03",
    title: "24 / 7 Availability",
    desc: "Early morning flights, late-night meetings, last-minute bookings. Our operations team is always reachable on call and WhatsApp.",
  },
  {
    id: "04",
    title: "GST Invoicing for Corporates",
    desc: "Full GST-compliant invoices, monthly billing cycles, and dedicated account managers for your business travel needs.",
  },
  {
    id: "05",
    title: "Immaculately Clean Vehicles",
    desc: "Professionally sanitized before every trip. Bottled water, charging cables, and amenities included as standard.",
  },
  {
    id: "06",
    title: "Real-Time Tracking",
    desc: "Share your live ride status with family or colleagues. Every long-distance journey is actively monitored by our team.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "We use JSR Travels exclusively for all our executive airport transfers in Indore. Punctual, professional, and always impeccably turned out.",
    name: "Vikram Mehta",
    role: "VP Operations · Indore",
  },
  {
    quote:
      "Our Ujjain pilgrimage was so peaceful because of JSR's thoughtful driver who knew every ghat and temple. Spotless car, smooth ride.",
    name: "Sunita Agarwal",
    role: "Retired Teacher · Bhopal",
  },
  {
    quote:
      "Booked the fleet for our wedding and guest transfers. Everything coordinated perfectly and the team went above and beyond.",
    name: "Rahul & Priya Joshi",
    role: "Newlyweds · Indore",
  },
];

export const SOCIAL = {
  instagram: "https://www.instagram.com/toofan_travels.indore",
  facebook: "https://www.facebook.com/share/1BwiKXqCjF/",
};

export const CONTACT = {
  wa: "919340403640",
  persons: [
    { name: "Rajesh Sharma", phone: "+91 93404 03640", tel: "+919340403640" },
    { name: "Kapil Sharma", phone: "+91 96695 61722", tel: "+919669561722" },
  ],
};
